// extracted by mini-css-extract-plugin
export default {"footer":"dvk9IC3kAMqz46VTTwUX","placeHolderShimmer":"Pq5hHNFSPMSi2trgwuuM"};